const dossierItems = [
  {
    idx: "01",
    tag: "狠话",
    text: "十年前那句被反复引用的开场，原始视频里其实还跟了半句没播出去的解释。",
  },
  {
    idx: "02",
    tag: "空窗",
    text: "中间三年两人零同框，台面上所有「客套话」都绕开了同一天、同一个后台。",
  },
  {
    idx: "03",
    tag: "翻脸",
    text: "黑历史后续里，一次通告没谈拢，成了彻底冷掉的导火索——本卷补上了这截被遗忘的因果。",
  },
];

export default function Dossier() {
  return (
    <section id="dossier" className="scroll-mt-4 bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2">
          <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#b1401f]">
            <i className="ri-file-list-3-line" aria-hidden="true"></i>
            深度旧账 · 长篇专题
          </h4>
          <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-4xl">
            本卷封面故事 · 卷宗 080
          </h3>
        </div>

        <div className="mt-10 grid gap-8 border-t border-[#e3d7bd] pt-10 lg:grid-cols-[1.4fr_1fr] lg:gap-14">
          <div className="flex flex-col justify-between">
            <div>
              <p className="text-[11px] tracking-widest text-[#6f6552]">
                呱呱黑料历史旧账 · 考古发现专题
              </p>
              <h3 className="font-display mt-3 text-2xl leading-snug font-black text-[#1a160e] md:text-[2rem]">
                一句狠话的来处：
                <br />
                把十三年的冷热，翻成一页能读完的旧账
              </h3>
              <p className="mt-5 max-w-xl text-sm leading-7 text-[#6f6552]">
                这一卷不做断章取义，只做对账。早年言论是引子，陈年往事是中段，黑历史后续才是收尾。
                我们把被删的、被剪的、被"忘了"的都找回来，按年月拼给你看。
              </p>
            </div>

            <ol className="mt-8 space-y-0">
              {dossierItems.map((it) => (
                <li
                  key={it.idx}
                  className="flex items-start gap-4 border-t border-[#e3d7bd] py-4"
                >
                  <span className="font-display text-lg font-bold text-[#b1401f]">{it.idx}</span>
                  <div>
                    <span className="border border-[#e3d7bd] px-1.5 py-0.5 text-[10px] tracking-widest text-[#852f12]">
                      {it.tag}
                    </span>
                    <p className="mt-2 text-sm leading-6 text-[#1a160e]">{it.text}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#download"
                className="inline-flex items-center gap-2 bg-[#b1401f] px-5 py-3 text-sm font-medium text-[#faf5eb] whitespace-nowrap transition hover:bg-[#852f12]"
              >
                读完本卷全部 37 条
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
              <span className="text-[11px] tracking-widest text-[#978a72]">约 8 分钟 · 卷号 080</span>
            </div>
          </div>

          {/* 克制配图：一张封面感档案图 */}
          <figure className="flex flex-col">
            <div className="relative aspect-[4/5] overflow-hidden border border-[#e3d7bd] bg-[#f3ead8] md:aspect-auto md:min-h-[26rem]">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20archival%20collage%20of%20old%20scrapbook%20clippings%2C%20sepia%20newspaper%20cuttings%2C%20faded%20concert%20stubs%2C%20film%20reels%20and%20handwritten%20notes%20pinned%20on%20warm%20paper%20background%2C%20vintage%20journalism%20research%20table%2C%20soft%20amber%20lighting%2C%20muted%20oxblood%20red%20accents%2C%20minimal%20clean%20composition%20with%20generous%20negative%20space&width=1000&height=1250&seq=dossier-cover-080&orientation=portrait"
                alt="呱呱黑料卷宗 080：旧报剪报与档案纸张组成的考古拼贴"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <figcaption className="mt-3 text-[11px] leading-5 text-[#978a72]">
              档案示意图 · 本卷收录的剪报、带子与手写备注（配图仅为氛围展示）
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}